import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronRight, faChevronUp, faChevronDown, faDownload, faEye, faLink, faShareSquare, faTrashAlt, faSearch, faPlus, faTimes, faEllipsisH, faKey, faCheck, faThLarge, faFileAlt, faFolderOpen, faRefresh, faSpinner, faUndo } from '@fortawesome/free-solid-svg-icons';

library.add(faChevronRight, faDownload, faEye, faLink, faShareSquare, faTrashAlt, faSearch, faChevronUp, faChevronDown, faPlus, faTimes, faEllipsisH, faKey, faCheck, faThLarge, faFileAlt, faFolderOpen, faRefresh, faSpinner, faUndo);

Vue.component('fa-icon', FontAwesomeIcon);